import { z } from 'zod';

export const ModuleStatusSchema = z.enum(['active', 'alpha', 'archive']);
export type ModuleStatus = z.infer<typeof ModuleStatusSchema>;

export const ModuleVisibilitySchema = z.enum(['public', 'members']);
export type ModuleVisibility = z.infer<typeof ModuleVisibilitySchema>;

export const ModuleTagSchema = z.enum([
  'agent',
  'ui',
  'data',
  'infra',
  'research',
  'docs',
  'reference',
  'messaging',
  'routing',
  'design',
]);
export type ModuleTag = z.infer<typeof ModuleTagSchema>;

export const ModuleSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  url: z.string().url(),
  description: z.string(),
  status: ModuleStatusSchema,
  visibility: ModuleVisibilitySchema,
  tags: z.array(ModuleTagSchema).readonly(),
  repoUrl: z.string().url().optional(),
  updatedAt: z.string().datetime().optional(),
});
export type Module = z.infer<typeof ModuleSchema>;

export const CatalogResponseSchema = z.object({
  modules: z.array(ModuleSchema).readonly(),
});
export type CatalogResponse = z.infer<typeof CatalogResponseSchema>;

export const STATUS_ORDER: Record<ModuleStatus, number> = {
  active: 0,
  alpha: 1,
  archive: 2,
} as const;
